export default {
  methods: {
		// 投票挂载，设置问卷投票
		mountedVote() {
      // 每个选项添加 ｛optCount 选择后的投票数 ， percent 百分比｝
			if(this.question.v_vote){
				let maps = {} 
				this.question.v_vote.list.forEach(i=>{
					maps[i.optionId] = {
            optCount: i.optCount,
            percent: i.votingRatio
          }
				})
				// options 挂数据optCount，percent
				this.question.options.forEach(i=>{
					i.optCount = maps[i.tenantId] && maps[i.tenantId].optCount || 0
					i.percent = maps[i.tenantId] && maps[i.tenantId].percent || '0%'
				})
			}else{
				// 设置默认
				this.question.v_vote = {
					list: []
				}
				this.question.options.forEach(i=>{
					i.optCount = 0
					i.percent = '0%'
				})
			}
		}
	}
}